import Table from "components/Table";
import { ROW_PER_PAGE_OPTIONS } from "config";
import { useItemRowTaskColumns, useParcelRowTaskColumns } from "domains/Task/types/Column";
import { Axe, EActionType, Items, Parcel, Stop, TaskMission } from "generated/graphql";
import React, { useMemo, useState } from "react";
import Dialog from "ui/Dialog";
import { useParcelListTaskStyles } from "./styles";

interface IDetailsParcelMsg {
  openDialogDetails: boolean;
  onCloseDialogDetails: () => void;
  axe?: TaskMission | Axe;
  parcel?: Parcel[];
  stops?: Stop[];
  currentPage?: number;
  countTotal?: number;
  setRowsPerPage?(length: number): void;
  items?: Items[];
  stop?: Stop;
}
export const DetailsParcelMsg = ({
  openDialogDetails,
  onCloseDialogDetails,
  stops,
  parcel,
  setRowsPerPage,
  items,
  stop,
}: IDetailsParcelMsg) => {
  const addressPickup = useMemo(() => {
    return stops?.map((stop: Stop) => (stop?.action === EActionType.Pickup ? stop?.address?.address : null));
  }, [stops]);
  const columnsParcelTask = useParcelRowTaskColumns();
  const columsItem = useItemRowTaskColumns();
  const [page, setPage] = useState(0);
  const [countTotal, setCountTotal] = useState(0);
  const parcelTaskStyle = useParcelListTaskStyles();

  return (
    <>
      <Dialog
        open={openDialogDetails}
        handleClose={onCloseDialogDetails}
        title={`${stop?.address?.address || addressPickup}`}
        maxWidth="lg"
        height="600px"
        closeButtonStyle={{ display: "none" }}
      >
        <div className={parcelTaskStyle.tableDetailsTask}>
          <Table
            tableWidth="100%"
            rowsIdentifier="_id"
            columns={items?.length > 0 ? columsItem : columnsParcelTask}
            data={items?.length > 0 ? items : parcel}
            rowsPerPageOptions={ROW_PER_PAGE_OPTIONS}
            rowsPerPage={10}
            countTotal={countTotal}
            setRowsPerPage={setRowsPerPage}
            currentPage={page}
          />
        </div>
      </Dialog>
    </>
  );
};
export default DetailsParcelMsg;
